<template>
  <v-main class="invicta">
    <v-row>
      <v-col cols="12">
        <div class="info-wrapper pa-6">
          <div class="info-header-wrapper text-left">
            <img
              class="div-1 info-icon ma-md-3"
              :src="paymentStatus == 'CONFIRMED' ? success_icon : failure_icon"
              width="38"
              height="38"
            />
            <div class="div-2 info-title mt-md-0 mt-3">
              {{ paymentStatus == 'CONFIRMED' ? $t('payment.header_success') : $t('payment.header_failure') }}
            </div>
            <div class="div-3 info-subtitle mt-3" v-if="reservationIds && reservationIds.length">
              <span class="mr-2">{{ $t('payment.header_subtitle') }}</span>
              <span
                class="info-bold mr-2"
                v-for="(item, index) in reservationIds"
                :key="index">
                {{ item }}{{ reservationIds.length > index + 1 ? ',' : '' }}
              </span>
            </div>
          </div>
          <div class="info-body-wrapper mt-12 text-left">
            <div class="info-message" v-if="paymentStatus == 'CONFIRMED'">
              {{ $t('payment.body_success_1') }}<br/>
              {{ $t('payment.body_success_2') }}
            </div>
            <div class="info-message" v-else>
              {{ $t('payment.body_failure_1') }}<br/>
              {{ $t('payment.body_failure_2') }}
            </div>
            <Button
              :round="true"
              :uppercase="true"
              class="info-button text-uppercase mt-12"
              v-if="paymentStatus == 'CONFIRMED'"
              @click="$router.push({name: 'dashboardView', query: {selected: 'deposits'}})"
            >
              {{ $t('payment.button_text_success') }}
            </Button>
            <Button
              :round="true"
              :uppercase="true"
              class="info-button text-uppercase mt-12 w-sm-100"
              v-else
              @click="$router.push({name: 'dashboardView', query: {selected: 'reservations'}})"
            >
              {{ $t('payment.button_text_failure') }}
            </Button>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from "vue";
import { Button } from 'design-system-ui-components'
import axios from "axios";

export default {
  components: {
    Button
  },
  data() {
    return {
      paymentStatus: '',
      paymentId: '',
      reservationIds: [],
      checkHandler: null
    }
  },
  computed: {
  },
  setup: () => {
    const store = useStore()
    const success_icon = computed(() => {
      return require('../assets/icons/payment_success.svg');
    })
    const failure_icon = computed(() => {
      return require('../assets/icons/payment_failure.svg');
    })
    return {
      success_icon,
      failure_icon,
      oidcUser: computed(() => store.getters['oidcStore/oidcUser'])
    }
  },
  created() {
    this.paymentStatus = this.$route.query?.paymentStatus;
    this.paymentId = this.$route.query?.paymentId;
    if(Array.isArray(this.$route.query?.reservationId))
      this.reservationIds = this.$route.query?.reservationId;
    else {
      this.reservationIds = [this.$route.query?.reservationId]; 
    }
  },
  mounted() {
    this.$store.dispatch('breadcrumbModule/setRoute', []);
    if(this.paymentStatus == 'CONFIRMED') {
      this.checkHandler = setInterval(() => {
        axios.get(`/api/reservation/check_deposit?reservations_ids=[${this.reservationIds}]`)
        .then(result => {
          if(result.data && result.data.deposit_exists){
            if(this.$vuetify.display.mobile) {
              this.$router.push({name: 'depositsComponent'});
            } else {
              this.$router.push({name: 'dashboardView', query: {selected: 'deposits'}});
            }
            clearInterval(this.checkHandler);
          }
        }).catch(error => {
          console.error(error);
        })
      }, 5000)

      window._hsq = window._hsq || []
      window._hsq.push(['identify',{ email: this.oidcUser.email }])
      window._hsq.push([
        'trackCustomBehavioralEvent',
        {
          name: process.env.VUE_APP_HS_PAID_RESERVATION_EVENT_NAME,
          properties: {
            reservations: this.reservationIds.toString()
          }
        },
      ]);
    }
  },
  unmounted() {
    if(this.checkHandler) {
      clearInterval(this.checkHandler);
    }
  }
}

</script>

<style lang="scss" scoped>

  @import "../../node_modules/design-system-ui-components/dist/all.min.css";
  .invicta {
    background: $ds-secondary-300;
  }
  .v-row, .v-col {
    margin: 0px;
    padding: 0px;
  }
  .info-header-wrapper {
    .info-title {
      @include nsb-gentium-bold;
      font-size: 28px;
      line-height: 40px;
    }
    .info-subtitle {
      @include nsb-font-header;
      font-size: 16px;
      line-height: 26px;
    }
    .info-bold {
      @include nsb-font-header-bold;
      font-size: 16px;
      line-height: 26px;
    }
  }
  .info-wrapper {
    margin-top: 64px;
    background: white;
    max-width: 588px;
    margin: 64px auto;
  }
  .info-body-wrapper {
    margin-left: 0px;
    @include nsb-font-header;
    font-size: 16px;
    line-height: 26px;
  }
  .info-button {
    @include nsb-font-header-bold;
    font-size: 14px;
    line-height: 21px;
    color: white;
    width: 100%;
  }

  @media (min-width: 960px) {
  .invicta {
    background: transparent;
  }
    .info-wrapper {
      margin: 120px auto;
    }
    .info-header-wrapper {
      display: grid;
      grid-template-columns: 80px auto;
      grid-template-rows: repeat(2, auto);
      grid-column-gap: 0px;
      grid-row-gap: 0px;
    }

    .div-1 { grid-area: 1 / 1 / 3 / 2; }
    .div-2 { grid-area: 1 / 2 / 2 / 3; }
    .div-3 { grid-area: 2 / 2 / 3 / 3; }

    .info-body-wrapper {
      margin-left: 80px;
    }
    .info-button {
      width: auto;
    }
  }
</style>